module.exports = __webpack_public_path__ + "img/logo.1db2686c.jpg";